import React from 'react';
import PropTypes from 'prop-types';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import SubMenuColumn from 'components/navV2/navPrimarySubMenu/SubMenuColumn';

const {
  PRIMARY: { REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS },
} = NAV_DATA;

const SingleRowColContainer = ({ data, className }) => {
  return (
    <div className={className}>
      {data.children.map((child, i) => {
        return (
          <SubMenuColumn
            headline={child.headline}
            links={child.children}
            borderLeft={child.borderLeft}
            twoColumns={child.twoColumns}
            key={i}
          />
        );
      })}
    </div>
  );
};

SingleRowColContainer.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    }),
    userActionsLinks: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        title: PropTypes.string,
      })
    ),
    title: PropTypes.string,
    id: PropTypes.oneOf([REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS]),
    isActive: PropTypes.bool,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string,
        borderLeft: PropTypes.bool,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
          })
        ),
      })
    ).isRequired,
  }),
  className: PropTypes.string,
};

export default SingleRowColContainer;
